import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useAppSelector } from '../../../hooks';
import { placeQueryData, userRoles } from '../../../shared';
import { placeApi } from '../../../store/services';
import styles from './selectHospital.module.scss';

export interface ISelectHospital {
 selectValue: string;
 handleSelectChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
 hasOnlineOption?: boolean;
}

export const SelectHospital: FC<ISelectHospital> = ({
 selectValue,
 handleSelectChange,
 hasOnlineOption,
}) => {
 const { t } = useTranslation();
 const currentUser = useAppSelector(
  ({ userReducer }) => userReducer.currentUser,
 );
 const { data: hospitals } = placeApi.useFetchPlaceListQuery(placeQueryData, {
  skip: !currentUser,
 });

 const options = hasOnlineOption
  ? [
     { value: '', label: t('adminPanel.form.allHospitals') },
     { value: 'online', label: t('adminPanel.form.online') },
     ...(hospitals?.items.map((place) => ({
      value: place._id,
      label: place.title,
     })) || []),
    ]
  : [
     { value: '', label: t('adminPanel.form.allHospitals') },
     ...(hospitals?.items.map((place) => ({
      value: place._id,
      label: place.title,
     })) || []),
    ];

 return (
  <div className={styles.select_hospital_wrap}>
   {currentUser?.role !== userRoles.rehabilitator ? (
    <select value={selectValue || ''} onChange={handleSelectChange}>
     {options.map((option) => (
      <option key={option.value} value={option.value}>
       {option.label}
      </option>
     ))}
    </select>
   ) : (
    <p className={styles.hospital_title}>
     {currentUser.portfolio?.places[0].title}
    </p>
   )}
  </div>
 );
};
